import React from 'react';

const Home = () => {
  return (
    <div className="min-h-screen flex flex-col items-center pt-20 px-4">

      {/*
      <div className="absolute top-0 left-0 w-full h-[500px] bg-gradient-to-br from-indigo-500 to-purple-600 rounded-b-[40%] -z-10 opacity-40"></div>
      <div className="absolute top-0 left-0 w-full h-[500px] bg-gradient-to-br from-gray-300 to-gray-100 rounded-b-[40%] -z-10 opacity-20"></div>
      */}

      <div className="max-w-7xl w-full flex flex-col md:flex-row items-center justify-between gap-12">
        {/* Texto a la izquierda */}
        <div className="flex-1 text-left">
          <h1 className="text-4xl font-bold text-blue-700 mb-6">Bienvenido a FancyPlus</h1>
          <p className="text-lg text-gray-700 mb-4">
            La salud es el pilar de una vida plena. Monitorear tus signos vitales de forma constante permite detectar anomalías a tiempo, mejorando la prevención y el tratamiento de enfermedades.
          </p>
          <p className="text-lg text-gray-700 mb-4">
            Además, una buena corrección de postura reduce dolores musculares, mejora la respiración y contribuye al bienestar general. Con FancyPlus, tu salud está en buenas manos.
          </p>
        </div>

        {/* Imagen a la derecha */}
        <div className="flex-1">
          <img 
            src="https://concienciasaludable.uchile.cl/wp-content/uploads/2025/04/1-b8c9f702.jpg" 
            alt="Salud y postura" 
            className="w-full rounded-lg shadow-lg object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
